export const GRAPHQL_API_URI = 'https://api.iot.staging.omcn.it/graphql'
// export const GRAPHQL_API_URI = 'https://api.iot.omcn.it/graphql'
